import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import React from "react";
import { DeleteDialog } from "../components";
import { routes } from "utilities/routing/generatedRoutes";
import ConfirmCopyModal from "components/modals/ConfirmCopyModal";

interface Props {
  optionsPanelData: server.dto.OptionsPanelDataV2
  listUrl: string
  wordTemplateForListViewId: number
}

const WordTemplateForListViewOptionsPanel = (props: Props) => {
  const [isDeleting, setIsDeleting] = React.useState<boolean>(false);
  const [isCopying, setIsCopying] = React.useState<boolean>(false);

  const onDelete = async () => {
    await window.CoreApi.WordTemplateForListView.DeleteWordTemplateForListView(props.wordTemplateForListViewId);
    window.location.href = props.listUrl;
  };

  const onCopy = async () => {
    const res = await window.CoreApi.WordTemplateForListView.CopyWordTemplateForListView(props.wordTemplateForListViewId);
    return res.data;
  };

  return <>
    <GeneralOptionsPanel
      data={props.optionsPanelData}
      links={[
        {
          href: props.listUrl,
          text: RESX.Buttons.ListView,
          visible: true
        }, {
          text: RESX.Buttons.btnCopy,
          onClick: () => { setIsCopying(true); },
          visible: true
        }, {
          onClick: () => { setIsDeleting(true); },
          text: RESX.Buttons.btnDelete,
          visible: true,
        }
      ]}
    />
    <DeleteDialog
      spinForever
      isOpen={isDeleting}
      onDelete={onDelete}
      handleClose={() => { setIsDeleting(false); }}
      message={RESX.GeneralWarnings.DeleteSure}
    />
    <ConfirmCopyModal
      isOpen={isCopying}
      apiCall={onCopy}
      onClose={() => { setIsCopying(false); }}
      onSuccess={(itemId) => window.location.href = routes.wordTemplateForListView_Detail(itemId).absolute}
    />
  </>;
};

export default WordTemplateForListViewOptionsPanel;